import http from 'http'

const state = {
}

const getters = {
}

const actions = {
  /**
   * 获取我创建的访问密钥对列表
   */
  async getAccessList ({ commit }) {
    try {
      return await http.access.getAccessList()
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },

  /**
   * 新增访问密钥
   */
  async addAccess ({ commit }, options) {
    try {
      return await http.access.addAccess(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },

  /**
   * 修改访问密钥
   */
  async updateAccess ({ commit }, options) {
    try {
      await http.access.updateAccess(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },

  /**
   * 删除访问密钥
   */
  async deleteAccess ({ commit }, accessId) {
    try {
      await http.access.deleteAccess(accessId)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },

  /**
   * 停用访问密钥
   */
  async disableAccess ({ commit }, accessId) {
    try {
      await http.access.disableAccess(accessId)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },

  /**
   * 启用访问密钥
   */
  async enableAccess ({ commit }, accessId) {
    try {
      await http.access.enableAccess(accessId)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  }
}

const mutations = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
